var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n  Test your knowledge of the Core 4 "),_c('br'),_vm._v("and our highest incident categories.\n")])
}]

export { render, staticRenderFns }